/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Guide_Ghost_HintInputs */

const en_us2_body_assessment_guide_ghost_hint = /** @type {(inputs: Body_Assessment_Guide_Ghost_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your last photo shows faintly: line your body up with it to repeat the pose.`)
};

const pt_br2_body_assessment_guide_ghost_hint = /** @type {(inputs: Body_Assessment_Guide_Ghost_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua última foto aparece clarinha: encaixe o corpo nela para repetir a posição.`)
};

const es_419_body_assessment_guide_ghost_hint = /** @type {(inputs: Body_Assessment_Guide_Ghost_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu última foto se ve tenue: alinea tu cuerpo con ella para repetir la pose.`)
};

const pt_pt2_body_assessment_guide_ghost_hint = /** @type {(inputs: Body_Assessment_Guide_Ghost_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua última foto aparece esbatida: encaixa o corpo nela para repetir a posição.`)
};

const fr_fr2_body_assessment_guide_ghost_hint = /** @type {(inputs: Body_Assessment_Guide_Ghost_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta dernière photo apparaît en transparence : aligne ton corps dessus pour reprendre la même pose.`)
};

const de_de2_body_assessment_guide_ghost_hint = /** @type {(inputs: Body_Assessment_Guide_Ghost_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein letztes Foto ist schwach eingeblendet: Richte deinen Körper daran aus, um die Pose zu wiederholen.`)
};

const it_it2_body_assessment_guide_ghost_hint = /** @type {(inputs: Body_Assessment_Guide_Ghost_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua ultima foto appare in trasparenza: allinea il corpo con essa per ripetere la posa.`)
};

/**
* | output |
* | --- |
* | "Your last photo shows faintly: line your body up with it to repeat the pose." |
*
* @param {Body_Assessment_Guide_Ghost_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_guide_ghost_hint = /** @type {((inputs?: Body_Assessment_Guide_Ghost_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Guide_Ghost_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_guide_ghost_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_guide_ghost_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_guide_ghost_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_guide_ghost_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_guide_ghost_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_guide_ghost_hint(inputs)
	return en_us2_body_assessment_guide_ghost_hint(inputs)
});
export { body_assessment_guide_ghost_hint as "body-assessment.guide_ghost_hint" }